import type {MaterialStorage} from '@domain/material-storage'
import {
  CurrentMaterialStoragesQueryKey,
  useAddStorageDatamartConnection
} from '@domain/material-storage'
import {useNotification} from '@hconnect/uikit'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {settingsQueryClient} from '../../../common/providers/QueryProvider'
import type {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

export const useAddDatamartConnection = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useAddStorageDatamartConnection({
    onError: (error) => {
      const data = (error as AxiosError<ErrorResponse>).response?.data
      notifyIfErrorMessage(data?.message, raiseError, notify)
    },
    onSuccess: (updatedStorage, variables) => {
      notify('success', t('success.addDatamartConnection'))
      const prevStorages = settingsQueryClient.getQueryData<MaterialStorage[]>([
        CurrentMaterialStoragesQueryKey,
        variables.plantCode
      ])
      if (!prevStorages) {
        throw new Error('Bug: storage query should be loaded to add a new storage')
      }
      const prevStorage = prevStorages.find((storage) => storage.id === variables.storageId)
      if (!prevStorage) {
        throw new Error('Bug: storage should be available in query before editing')
      }
      const newStorages = prevStorages.map((storage) =>
        storage.id === variables.storageId ? updatedStorage : storage
      )
      settingsQueryClient.setQueryData(
        [CurrentMaterialStoragesQueryKey, variables.plantCode],
        newStorages
      )
    }
  })
}
